import { ComputerQuestionPage } from './ComputerQuestionPage';
export default ComputerQuestionPage;